<template>
  <div class="code-input" aria-label="Registration code input">
    <div
      v-for="(slot, index) in slots"
      :key="index"
      class="slot"
      :class="{
        'slot--active': index === cursor,
        'slot--filled': slot !== null,
        'slot--alpha': index <= 2,
        'slot--numeric': index === 3 || index === 4,
        'slot--alnum': index === 5,
      }"
      :aria-label="`Character ${index + 1}`"
    >
      <span class="slot-char">{{ slot ?? '' }}</span>
      <span v-if="index === cursor" class="slot-cursor" aria-hidden="true" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  slots: (string | null)[];
  cursor: number;
}>();
</script>

<style scoped>
.code-input {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  align-items: center;
  padding: 0.5rem 0;
}

.slot {
  position: relative;
  width: 3rem;
  height: 3.75rem;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.75rem;
  font-weight: 700;
  font-family: 'Courier New', monospace;
  letter-spacing: 0;
  background: #f9fafb;
  transition: border-color 0.15s, background 0.15s;
}

.slot--active {
  border-color: #2563eb;
  background: #eff6ff;
}

.slot--filled {
  border-color: #6b7280;
  background: #fff;
}

.slot-char {
  color: #111827;
  user-select: none;
}

.slot-cursor {
  position: absolute;
  bottom: 6px;
  left: 50%;
  transform: translateX(-50%);
  width: 1.5rem;
  height: 2px;
  background: #2563eb;
  animation: blink 1s step-end infinite;
}

@keyframes blink {
  50% { opacity: 0; }
}

@media (prefers-color-scheme: dark) {
  .slot {
    border-color: #374151;
    background: #1f2937;
  }

  .slot--active {
    border-color: #3b82f6;
    background: #1e3a5f;
  }

  .slot--filled {
    border-color: #6b7280;
    background: #111827;
  }

  .slot-char {
    color: #f9fafb;
  }
}
</style>
